export function prop (o, members = '') {
  if (typeof members === 'string') {
    members = members ? members.split('.') : []
  }
  if (!Array.isArray(members)) {
    throw new Error('members required types is String or Array')
  }
  if (members.length === 0) {
    return o
  }
  if (typeof o !== 'object' || o === null) {
    return undefined
  }

  let val = o
  for (let i = 0; i < members.length; ++i) {
    const name = members[i]
    if (!name || typeof val !== 'object' || val === null || name in val === false) {
      return undefined
    }
    val = val[name]
  }
  return val
}
